module.exports = __webpack_public_path__ + "img/phase1-sample-02.198aace0.jpg";